import { Timeline as TimelineMantine } from '@mantine/core'
import styled from 'styled-components'

export const Timeline = styled(TimelineMantine)`
  .mantine-Timeline-itemTitle {
    color: ${({ theme }) => theme.cor9};
    font-size: 18px;
  }

  .mantine-Timeline-itemContent {
    color: ${({ theme }) => theme.cor66};
  }

  .mantine-Timeline-itemBullet {
    background-color: ${({ theme }) => theme.cor71} !important;
    border: none !important;
  }

  .mantine-Timeline-item[data-active]::before {
    border-left-color: #33cc99 !important;
  }

  .mantine-Timeline-item::before {
    border-left-color: ${({ theme }) => theme.cor7}!important;
  }

  .mantine-Timeline-itemBullet[data-active] {
    background-color: #33cc99 !important;
    border: none !important;
  }

  padding-top: 5px;
  mask-image: linear-gradient(
    to bottom,
    transparent,
    black 5px,
    black calc(100% - 5px),
    transparent
  );
`

export const Data = styled.div`
  color: ${({ theme }) => theme.cor9};
  font-size: 14px;
`
